import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../services/auth.js';

export default function SignUp() {
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await auth.signUp({ email: form.email.trim(), password: form.password, name: form.name.trim() });
      nav(`/confirm?email=${encodeURIComponent(form.email.trim())}`);
    } catch (e2) {
      setErr(e2.message ?? 'Sign up failed');
    } finally { setBusy(false); }
  }

  return (
    <div className="container-narrow page-auth">
      <span className="eyebrow">A new ledger</span>
      <h2 className="mt-8 mb-32">Open your inventory.</h2>
      <div className="card">
        <form onSubmit={onSubmit}>
          {err && <div className="alert error mb-18">{err}</div>}
          <div className="field">
            <label>Name</label>
            <input required value={form.name} onChange={set('name')} />
          </div>
          <div className="field">
            <label>Email</label>
            <input type="email" autoComplete="email" required value={form.email} onChange={set('email')} />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" autoComplete="new-password" required minLength={10} value={form.password} onChange={set('password')} />
            <div className="hint">Minimum 10 characters, with upper, lower, and number.</div>
          </div>
          <button className="btn btn-primary btn-block" disabled={busy}>
            {busy ? 'Creating…' : 'Create account'}
          </button>
        </form>
      </div>
      <p className="muted center mt-20">
        Already have one? <Link to="/signin">Sign in</Link>
      </p>
    </div>
  );
}
